import { DownOutlined } from '@ant-design/icons';
import { cx } from '@emotion/css';
import { Typography } from 'antd';

interface OrderRowProps {
  title: string;
  value: string | React.ReactNode;
  extra?: React.ReactNode;
  showArrow?: boolean;
  arrowDirection?: 'up' | 'down';
  onClick?: () => void;
}

export const OrderRow = (props: OrderRowProps) => {
  const { title, value, extra, showArrow = false, arrowDirection = 'down', onClick } = props;

  const valueNode =
    typeof value === 'string' ? (
      <Typography.Paragraph
        className="!text-[#232426] max-w-[270px] !mb-0 !text-right"
        ellipsis={{ rows: 2, tooltip: value }}
      >
        {value}
      </Typography.Paragraph>
    ) : (
      value
    );

  return (
    <div className="flex flex-col">
      <div
        className={cx(
          'grid grid-cols-[1fr_auto_auto] items-start',
          showArrow ? 'cursor-pointer' : '',
        )}
        onClick={showArrow ? onClick : undefined}
      >
        <span className="text-[#84868C]">{title}</span>
        {valueNode}
        {showArrow && (
          <DownOutlined
            className="ml-1.5 text-[10px] mt-1.5"
            style={{
              transform: arrowDirection === 'up' ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease',
            }}
          />
        )}
      </div>
      <div className="flex justify-end">{extra}</div>
    </div>
  );
};
